import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { dataPropType } from "../../../propTypes";
import { reportingYear } from "../../../constants";
import { withStyles } from "@material-ui/styles";
import styleConstants from "../../../styleConstants";
import ChangeByMethodTable from "./ChangeByMethodTable";
import MethodMixAndShareTable from "./MethodMixAndShareTable";
import MethodVsSectorTable from "./MethodVsSectorTable";
import AnnexTable from "./AnnexTable";

const styles = {
  container: {
    paddingBottom: "2rem",
    backgroundColor: `${styleConstants.colors.gray1}`
  }
};

const Annex = props => (
  <div id="annex" className={props.classes.container}>
    <h3 className="section-heading">Users</h3>

    <AnnexTable
      id="tableA1"
      reference="Table A.1"
      title={`Users of Contraception by Sector, ${reportingYear}`}
      subtitle="Segmented by Method"
      onDownloadCsv={() => {
        props.onDownloadCsv("annex.contraceptionUsersTable");
      }}
    >
      <MethodVsSectorTable
        data={props.data.widgetData.annex.contraceptionUsersTable}
      />
    </AnnexTable>

    <AnnexTable
      id="tableA2"
      reference="Table A.2"
      title={`User Method Mix and Method Share by Sector, ${reportingYear}`}
      subtitle="Segmented by Method"
      onDownloadCsv={() => {
        props.onDownloadCsv("annex.userMethodMixAndShareTable");
      }}
    >
      <MethodMixAndShareTable
        data={props.data.widgetData.annex.userMethodMixAndShareTable}
      />
    </AnnexTable>

    <AnnexTable
      id="tableA3"
      reference="Table A.3"
      title="Change in Users, 2020-2030"
      subtitle="Segmented by Method"
      onDownloadCsv={() => {
        props.onDownloadCsv("annex.changeInUsersTable");
      }}
    >
      <ChangeByMethodTable
        data={props.data.widgetData.annex.changeInUsersTable}
        show10YearChange={true}
      />
    </AnnexTable>

    <h3 className="section-heading">Cost</h3>

    <AnnexTable
      id="tableA4"
      reference="Table A.4"
      title={`Cost of Contraception by Sector, ${reportingYear}`}
      subtitle="Segmented by Method"
      onDownloadCsv={() => {
        props.onDownloadCsv("annex.contraceptionCostTable");
      }}
    >
      <MethodVsSectorTable
        data={props.data.widgetData.annex.contraceptionCostTable}
      />
    </AnnexTable>

    <AnnexTable
      id="tableA5"
      reference="Table A.5"
      title={`Cost Method Mix and Method Share by Sector, ${reportingYear}`}
      subtitle="Segmented by Method"
      onDownloadCsv={() => {
        props.onDownloadCsv("annex.costMethodMixAndShareTable");
      }}
    >
      <MethodMixAndShareTable
        data={props.data.widgetData.annex.costMethodMixAndShareTable}
      />
    </AnnexTable>

    <AnnexTable
      id="tableA6"
      reference="Table A.6"
      title="Change in Costs, 2020–2030"
      subtitle="Segmented by Method"
      onDownloadCsv={() => {
        props.onDownloadCsv("annex.changeInCostTable");
      }}
    >
      <ChangeByMethodTable
        data={props.data.widgetData.annex.changeInCostTable}
        show10YearChange={true}
      />
    </AnnexTable>

    <h3 className="section-heading">Quantity</h3>

    <AnnexTable
      id="tableA7"
      reference="Table A.7"
      title={`Quantity of Contraception by Sector, ${reportingYear}`}
      subtitle="Segmented by Method"
      onDownloadCsv={() => {
        props.onDownloadCsv("annex.contraceptionQuantityTable");
      }}
    >
      <MethodVsSectorTable
        data={props.data.widgetData.annex.contraceptionQuantityTable}
        showTotals={false}
      />
    </AnnexTable>

    <AnnexTable
      id="tableA8"
      reference="Table A.8"
      title={`Quantity Method Share by Sector, ${reportingYear}`}
      subtitle="Segmented by Method"
      onDownloadCsv={() => {
        props.onDownloadCsv("annex.quantityMethodShareTable");
      }}
    >
      <MethodMixAndShareTable
        data={props.data.widgetData.annex.quantityMethodShareTable}
        showMix={false}
        showTotals={false}
      />
    </AnnexTable>

    <AnnexTable
      id="tableA9"
      reference="Table A.9"
      title="Change in Quantities, 2020–2030"
      subtitle="Segmented by Method"
      onDownloadCsv={() => {
        props.onDownloadCsv("annex.changeInQuantityTable");
      }}
    >
      <ChangeByMethodTable
        data={props.data.widgetData.annex.changeInQuantityTable}
        show10YearChange={true}
        showTotals={false}
      />
    </AnnexTable>
  </div>
);

Annex.propTypes = {
  data: dataPropType,
  onDownloadCsv: PropTypes.func.isRequired
};

export default memo(withStyles(styles)(Annex));
